import styled from "styled-components";
import {
  gradientTextStyles,
  Page,
  PrimaryButton,
  theme,
  typography,
} from "../Homepage/styles";

export const AlertsPage = styled(Page)`
  background: hsl(var(--hp-background));
  background-image: none;
`;

export const AlertsHero = styled.section`
  position: relative;
  padding: 104px 16px 32px;
  overflow: hidden;
  text-align: center;

  @media (min-width: 768px) {
    padding: 128px 24px 40px;
  }
`;

export const AlertsHeroBgGradient = styled.div`
  pointer-events: none;
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom right,
    hsl(var(--hp-primary) / 0.1) 0%,
    hsl(var(--hp-background)) 50%,
    hsl(var(--hp-accent) / 0.05) 100%
  );
`;

export const AlertsHeroBgRadial = styled.div`
  pointer-events: none;
  position: absolute;
  inset: 0;
  background: radial-gradient(
    ellipse at center,
    hsl(var(--hp-primary) / 0.15) 0%,
    transparent 70%
  );
`;

export const AlertsHeroInner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 768px;
  margin: 0 auto;
`;

export const AlertsHeroTitle = styled.h1`
  margin: 0 0 16px;
  color: ${theme.foreground};
  font-family: ${typography.fontFamily};
  font-size: 2.25rem;
  font-weight: ${typography.weights.bold};
  line-height: 1.2;

  @media (min-width: 768px) {
    font-size: 3.75rem;
  }

  span {
    ${gradientTextStyles}
  }
`;

export const AlertsHeroLead = styled.p`
  margin: 0;
  color: ${theme.textMuted};
  font-size: 1.125rem;
  line-height: 1.6;
`;

export const AlertsCta = styled.section`
  position: relative;
  padding: 80px 16px;
  overflow: hidden;
`;

export const AlertsCtaBg = styled.div`
  pointer-events: none;
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom right,
    hsl(var(--hp-primary) / 0.1) 0%,
    hsl(var(--hp-background)) 50%,
    hsl(var(--hp-accent) / 0.05) 100%
  );
`;

export const AlertsCtaInner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 768px;
  margin: 0 auto;
  text-align: center;
`;

export const AlertsCtaTitle = styled.h2`
  margin: 0 0 24px;
  color: ${theme.foreground};
  font-size: 1.875rem;
  font-weight: ${typography.weights.bold};
  line-height: 1.25;

  @media (min-width: 768px) {
    font-size: 3rem;
  }

  span {
    ${gradientTextStyles}
  }
`;

export const AlertsCtaLead = styled.p`
  margin: 0 0 32px;
  color: ${theme.textMuted};
  font-size: 1.125rem;
  line-height: 1.6;
`;

export const AlertsCtaButton = styled(PrimaryButton)`
  min-height: 48px;
  padding: 0 28px;
  font-size: 1rem;
`;

export const AlertsCoreSlot = styled.div`
  width: 100%;
`;
